import { fetchUtils, DataProvider, useRedirect  } from 'react-admin';
import { getPermissionsFromRoles, Permissions } from 'src/enterprise/ra-rbac';
import { roles } from './Roles';
import { getRoles, getUsername } from 'src/common/AuthFunctions';

export default {
    login: ({ username, password }) => {
        return fetchUtils.fetchJson(process.env.REACT_APP_API_BASE_URL+'/auth/login', {
            method: 'POST',
            body: JSON.stringify({username: username, password: password}),
        }).then(({ json }) => {
            localStorage.setItem('swatim_token', json.token);
            localStorage.setItem('swatim_refresh_token', json.refresh_token);

            return Promise.resolve();
        });
    },

    logout: () => {
        localStorage.removeItem('swatim_token');
        localStorage.removeItem('swatim_refresh_token');

        return Promise.resolve();
    },

    // called when the API returns an error
    checkError: ({ message, status }) => {
        if (status === 401) {
            if (localStorage.getItem('swatim_refresh_token')) {
                return fetchUtils.fetchJson(process.env.REACT_APP_API_BASE_URL+'/auth/token/refresh', {
                    method: 'POST',
                    body: JSON.stringify({refresh_token: localStorage.getItem('swatim_refresh_token')}),
                }).then(({ json }) => {
                    localStorage.setItem('swatim_token', json.token);
                    localStorage.setItem('swatim_refresh_token', json.refresh_token);
                    window.location.reload();
                    return Promise.resolve();
                });
            }

            localStorage.removeItem('swatim_token');
            localStorage.removeItem('swatim_refresh_token');

            return Promise.reject({
                message: message,
                logoutUser: false,
                redirectTo: '/',
            });
        }

        if (status === 403) {
            return Promise.reject({
                message: message,
                logoutUser: false,
                redirectTo: '/',
            });
        }

        return Promise.resolve();
    },

    // Force to login if token is not present
    checkAuth: () => {
        return localStorage.getItem('swatim_token')
            ? Promise.resolve()
            : Promise.reject();
    },

    isLoggedIn: () => {
        return localStorage.getItem('swatim_token') && localStorage.getItem('swatim_refresh_token');
    },

    // called when the user navigates to a new location, to check for permissions / roles
    getPermissions: async () => {
        return Promise.resolve(
            getPermissionsFromRoles({
                // static role definitions
                roleDefinitions:roles as Record<string, Permissions>,
                // roles of the current user
                userRoles: getRoles(),
            })
        )
    },

    getIdentity: async () => {
        return { 
            id: getUsername(), 
            fullName: getUsername()
        };
    },
};
